import { IsString } from "@pdfking/tfunc"
import { startswith } from "@pdfking/workflow/utils/strings"
import { url_parse } from "@pdfking/workflow/utils/urlutilities"

export default function check_url_is_ajax(parsed) {
  if (IsString(parsed)) {
    if (startswith(parsed, "#")) return false
    return check_url_is_ajax(url_parse(parsed))
  }
  if (parsed.protocol != "http:" && parsed.protocol != "https:") return false
  return (
    window.location.protocol == parsed.protocol &&
    window.location.hostname == parsed.hostname
  )
}
